// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-lens-image-type-switcher-float[data-v-b2f5f5e2]{align-items:center;display:flex;justify-content:flex-end;padding:10px 10px 0 0;position:fixed;z-index:997;pointer-events:none}.contact-lens-image-type-switcher-float .contact-lens-image-type-switcher[data-v-b2f5f5e2]{pointer-events:auto}", ""]);
// Exports
module.exports = exports;
